/* eslint-disable no-console */
import Catalogs from "./modules/Catalogs.storage";
import SharedData from "./modules/Shared.store";
import User from "./modules/User.store";
import EventListener from "./modules/EventListener.store";
import EventListenerRecord from "./modules/EventListenerRecord.store";
import ShoppingCart from "./modules/RelativeShoppingCart.store";
import RelativeBalance from "./modules/ParentPayments.store";
import SignupWizardStore from "../features/auth/presentation/signup_wizard/vuex/SignupWizard.store";
import {
  SET_API,
  SET_CAMPUS_OBJECT,
  SET_PERIOD,
  SET_PERIODS,
  SET_STORAGE,
  SET_EXPANDED,
} from "./mutation-types";

//Store created by depUtil plugin
export default {
  state: {
    api: null,
    storage: null,
    period: {
      idPeriod: "",
    },
    periods: [],
    campus: null, //TODO quitar
    expanded: false,
    user: "",
  },
  mutations: {
    [SET_STORAGE](state, storage) {
      state.storage = storage;
    },
    [SET_API](state, api) {
      state.api = api;
    },
    [SET_PERIODS](state, periods) {
      state.periods = periods;
    },
    [SET_PERIOD](state, periodObject) {
      state.period = periodObject;
      if (periodObject && periodObject.status) state.currentPeriod = periodObject;
    },
    [SET_CAMPUS_OBJECT](state, campusObject) {
      state.campus = campusObject;
    },
    [SET_EXPANDED](state, expanded) {
      state.expanded = expanded;
    },

  },
  modules: {
    User,
    Catalogs,
    SharedData,
    EventListener,
    EventListenerRecord,
    RelativeBalance,
    ShoppingCart,
    SignupWizardStore,
  },
  actions: {
    async setCampus({ commit, rootState }) {
      if (rootState.User.campus) {
        const campusData = await rootState.api.util.getCampusData(
          rootState.User.campus
        );

        commit(SET_CAMPUS_OBJECT, campusData);
      }
    },
    async setPeriods({ commit, rootState }) {

      const COMMUNICATION_USERS = [
        "DB6FF91E-E160-4FF6-9F8A-FC6CF8DF4CAC",
        "2F7AEE9B-1C29-4844-899D-8CE265F34A41",
      ];

      const MEXICO_COUNTRY_ID = "e0fb533c-dafd-4b86-8ff2-8b8327a0a41d";

      const sortPeriodsByIdDesc = (periods) => {
        return [...periods].sort((a, b) => b.idPeriodInt - a.idPeriodInt);
      };

      const findCurrentPeriod = (periods) => {
        return periods.find((period) => period.status === true) || periods[0];
      };

      const filterMexicoPeriods = (periods) => {
        return periods.filter(
          (period) => period.countryId == MEXICO_COUNTRY_ID
        );
      };

      const periods = await rootState.api.catalogs.getPeriods();

      const orderedPeriods = sortPeriodsByIdDesc(periods);

      commit(SET_PERIODS, orderedPeriods);

      if (COMMUNICATION_USERS.includes(rootState.User.type)) {
        const periodsMX = filterMexicoPeriods(orderedPeriods);

        if (rootState.period.idPeriod == "") {
          console.log("No hay nada, volver a setear el period COM");
          commit(SET_PERIOD, findCurrentPeriod(periodsMX));
        }
      } else { // not a com user, like normal user or cat user
        if (!rootState.period || rootState.period.idPeriod == "") {
          console.log("No hay nada, volver a setear el period OTHER");
          commit(SET_PERIOD, findCurrentPeriod(orderedPeriods));
        }
      }
    },
    async setExpanded({ commit }, expanded) {
      commit(SET_EXPANDED, expanded);
    },
    async setPeriod({ commit }, period) {
      commit(SET_PERIOD, period);
    },
  },
  getters: {
    idPeriod(state) {
      return state.period && state.period.idPeriod ? state.period.idPeriod : "";
    },
    idPeriodInt(state) {
      return state.period && state.period.idPeriodInt
        ? state.period.idPeriodInt
        : "";
    },
    period(state) {
      return state.period;
    },
    expanded(state) {
      return state.expanded;
    },
    periods(state) {
      return state.periods;
    },
  },
  setters: {
    expanded(state, expanded) {
      state.expanded = expanded;
    },
  },
};

export const STORE_NAMES = {
  GLOBALUTILS: "$_GLOBALUTILS",
  AppMenu: "$_AppMenu",
  KN_EXPLORE_CONFIG: "$_KN_EXPLORE_CONFIG",
  KN_EXPLORE_HISTORY: "$_KN_EXPLORE_HISTORY_CONFIG",
  KN_EXPLORE_BOOKMARKS: "$_KN_EXPLORE_BOOKMARKS_CONFIG",
  KN_MATERIALS_CONFIG: "$_KN_MATERIALS_CONFIG",
  KN_MATERIALS_CONFIG_FONTS: "$_KN_MATERIALS_CONFIG_FONTS",
  BECA_LIST: "$_BECA_LIST",
  FOLLOWUP: "$_FOLLOWUP",
  USERS: "$_USERS",
  USERS_PAYMENT: "$_USERS_PAYMENT",
  STUDENTS_MODAL: "$_STUDENTS_MODAL",
  CLASSES: "$_CLASSES",
  CLASSES_MODAL: "$_CLASSES_MODAL",
  CLASSES_LIST_MODAL: "$_CLASSES_LIST_MODAL",
  CLASSES_FORM: "$_CLASSES_FORM",
  CUSTOM_CLASSES_FORM: "$_CUSTOM_CLASSES_FORM",
  ASSIGN_CLASSES_MODAL: "$_ASSIGN_CLASSES_MODAL",
  USERS_FORM: "$_USERS_FORM",
  GROUPS: "$_GROUPS",
  CUSTOM_SUBJECTS: "$_CUSTOM_SUBJECTS",
  GROUPS_FORM: "$_GROUPS_FORM",
  NOTIFICATIONS: {
    MAIN: "$_NOTIFICATIONS",
    FORM: "$_NOTIFICATIONS_FORM",
    MODAL_GROUP_RECIPIENTS: "$_NOTI_MODAL_GROUP_RECIPIENTS",
    MODAL_PERSONAL_RECIPIENTS: "$_NOTI_MODAL_PERSONAL_RECIPIENTS",
  },
  EVALUATION: {
    INSTITUTIONAL_CRITERIAS: "$_INSTITUTIONAL_CRITERIAS",
    INSTITUTIONAL_CRITERIA_MODAL: "$_INSTITUTIONAL_CRITERIA_MODAL",
    PERIOD_SETS: "$_PERIOD_SETS",
    MODELS: "$_MODELS",
    MODELS_FORM: "$_MODELS_FORM",
  },
  VISIBILITY: "$_VISIBILITY",
  SUBJECTS: "$_SUBJECTS",
  VIEWER: "$_VIEWER",
  STUDENTS_FORM: "$_STUDENTS_FORM",
  REPORT_GRADE: "$_REPORT_GRADE",
  GENERAL_CONFIGURATION: "$_GENERAL_CONFIGURATION",
  CALLCENTER: {
    DASHBOARD: "$_CALLCENTER_DASHBOARD",
    BANK_STATEMENT: "$_BANK_STATEMENT",
    TRANSACTIONS: "$_TRANSACTIONS",
    RELATIVES_MODAL: "$_RELATIVES_MODAL",
    PAYMENT_FORM_MODAL: "$_PAYMENT_FORM_MODAL",
    NEW_PAYMENT_MODAL: "$_NEW_PAYMENT_MODAL",
    STUDENT_PROGRAM_CART: "$_STUDENT_PROGRAM_CART",
  },
  RELATIVES_FORM: "$_RELATIVES_FORM",
  CANCEL_PAYMENT_MODAL: "$_CANCEL_PAYMENT_MODAL",
  PAYMENTS: {
    CONFIGURATION: "$_PAYMENT_CONFIGURATION",
    CONFIGURATION_FORM: "$_CONFIGURATION_FORM",
    ADD_CONCEPT_FORM_MODAL: "$_ADD_CONCEPT_FORM_MODAL",
    LOANS_FORM_MODAL: "$_LOANS_FORM_MODAL",
    IMPORT_SCHOLARSHIP_FORM_MODAL: "$_IMPORT_SCHOLARSHIP_FORM_MODAL",
    CATALOGS: {
      ARTICLES: "$_PAYMENT_CATALOG_ARTICLES",
      ARTICLES_FORM: "$_PAYMENT_ARTICLE_FORM",
    },
  },
  BECAS: {
    BECA_LIST: "$_BECA_LIST",
    BECA_FORM: "$_BECA_FORM",
  },
  CONCEPTS: {
    CATALOGS: {
      CONCEPTS: "$_CONCEPT_CATALOG",
      CONCEPTS_FORM: "$_CONCEPT_FORM",
    },
  },
  MANAGEMENT_STORE: "$_MANAGEMENT_STORE",
};
